<ng-container>
    <h2 mat-dialog-title class="pv-dialog-title">
        <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
        <span class="pv-dialog-title-text">Edit Item Content</span>
        <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content class="pv-dialog-body">
        <form id="report_component_form"
            [formGroup]="formGroup"
            (ngSubmit)="attempt()"
            autocomplete="off"
        >
            <!-- TEXT EDITOR -->
            <quill-editor [styles]="{height: '500px', width: '1150px'}" [modules]="editorModules" formControlName="content"></quill-editor>

        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="pv-dialog-footer">
        <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
        <button type="button" mat-flat-button color="primary" (click)="attempt()">
            <mat-icon>check</mat-icon>
            Apply
        </button>
    </mat-dialog-actions>
</ng-container>
